import { GridLayoutItem } from '@progress/kendo-react-layout';
import { CustomgridLayoutWrapper } from 'admin/components/wrappers';
import AdminDropDown from 'app/components/AdminDropDown';
import { AdminTextField } from 'app/components/AdminTextField';
import { ProfileImageUploadCard } from 'app/components/ProfileImageUploadCard';
import React, { useState } from 'react';
import styled from 'styled-components';
import { AdminDatePicker } from 'app/components/AdminDatePicker';
import {
  AdminRiderRegistration,
  GeneralLookup,
  GeneralLookupWrapper,
} from 'services/openapi';
import {
  findObjectById,
  isoString,
  getLookupArray,
  isEmptyArray,
  findMatchingDivisionClassAndRemoveSelected,
} from 'utils/common';
import { defaultLookup } from './staticDatas';
import SimpleReactValidator from 'simple-react-validator';
import { FormSkeletonLoader } from 'app/components/FormSkeletonLoader';
import { AdminCheckBox } from 'app/components/AdminCheckbox';
import AdminCustomButton from 'app/components/AdminCustomButton';
import { useParams } from 'react-router-dom';
import { heightWeightModel } from '.';
import { CustomRadioButtonGroup } from 'app/components/CustomRadioButtonGroup';

type Props = {
  riderData: AdminRiderRegistration;
  setRiderdata: React.Dispatch<React.SetStateAction<AdminRiderRegistration>>;
  handleChange: (event: any) => void;
  action: string | undefined;
  lookUps: GeneralLookupWrapper[];
  categoryListFromTeam: GeneralLookup[];
  setCategoryListFromTeam: React.Dispatch<
    React.SetStateAction<GeneralLookup[]>
  >;
  divisionOneList: GeneralLookup[];
  setDivisionOnelist: React.Dispatch<React.SetStateAction<GeneralLookup[]>>;
  divisionTwoList: GeneralLookup[];
  setDivisionTwoList: React.Dispatch<React.SetStateAction<GeneralLookup[]>>;
  simpleValidator: React.MutableRefObject<SimpleReactValidator>;
  setImgSrc: React.Dispatch<React.SetStateAction<string | null>>;
  imgSrc: string | null;
  setImageFile: React.Dispatch<React.SetStateAction<Blob | undefined>>;
  riderDataLoading: boolean;
  isCategoryNotInTeam: boolean;
  setIsCategoryNotInTeam: React.Dispatch<React.SetStateAction<boolean>>;
  checkBacknumberTaken: (
    backNumber?: string,
    isTryIt?: boolean,
    riderId?: string,
  ) => void;
  isBacknumberTaken: boolean | null;
  setIsBacknumberTaken: React.Dispatch<React.SetStateAction<boolean | null>>;
  heightWeight: heightWeightModel | undefined;
  setHeightWeight: React.Dispatch<
    React.SetStateAction<heightWeightModel | undefined>
  >;
  isReturningRider: boolean;
  setIsReturningRider: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedReturningRider: React.Dispatch<
    React.SetStateAction<GeneralLookup | undefined>
  >;
  handleSearchInputChange: (e: any) => void;
  selectedReturningRider: GeneralLookup | undefined;
  returningRiderData: GeneralLookup[] | undefined;
  setSeasonValue: React.Dispatch<
    React.SetStateAction<GeneralLookup | undefined>
  >;
  setReturningRiderData: React.Dispatch<
    React.SetStateAction<GeneralLookup[] | undefined>
  >;
  previousSearchValueRef: React.MutableRefObject<string | undefined>;
  seasonValue: GeneralLookup | undefined;
  onCancelClick: () => void;
  getRidersList: (
    seasonId?: string,
    backNumber?: string,
    name?: string,
    categoryId?: string,
    divisionId?: string,
    teamId?: string,
    isErrorToastEnabled?: boolean,
  ) => void;
  onRiderDropdownScrollBottom: () => void;
};

const RiderInformationFirstBlock = ({
  riderData,
  handleChange,
  setRiderdata,
  action,
  lookUps,
  categoryListFromTeam,
  setCategoryListFromTeam,
  divisionOneList,
  setDivisionOnelist,
  divisionTwoList,
  setDivisionTwoList,
  simpleValidator,
  setImgSrc,
  imgSrc,
  setImageFile,
  riderDataLoading,
  isCategoryNotInTeam,
  setIsCategoryNotInTeam,
  checkBacknumberTaken,
  isBacknumberTaken,
  setIsBacknumberTaken,
  heightWeight,
  setHeightWeight,
  isReturningRider,
  setIsReturningRider,
  setSelectedReturningRider,
  handleSearchInputChange,
  selectedReturningRider,
  returningRiderData,
  setSeasonValue,
  setReturningRiderData,
  previousSearchValueRef,
  seasonValue,
  onCancelClick,
  getRidersList,
  onRiderDropdownScrollBottom,
}: Props) => {
  const [forceUpdate, setForceUpdate] = useState(false);
  let { id: riderId } = useParams();

  const onDataChangeTeam = e => {
    setRiderdata({
      ...riderData,
      team: e,
      category: defaultLookup,
      divisionClassOne: defaultLookup,
      divisionClassTwo: defaultLookup,
    });
    let teamLookUpList = getLookupArray('ACTIVETEAM', lookUps);
    const matchingObject = findObjectById(teamLookUpList, e.id);
    if (matchingObject) {
      const { children } = matchingObject;
      setCategoryListFromTeam(children!);
      setDivisionOnelist([]);
      setDivisionTwoList([]);
    }
    setIsCategoryNotInTeam(e.children.length === 0 ? true : false);
    const arrays = ['Category', `Division/Classes One`, `Division/Classes Two`];
    e.children.length === 0 &&
      arrays.forEach(field => {
        simpleValidator.current.hideMessageFor(field);
        simpleValidator.current.visibleFields = [];
        setForceUpdate(!forceUpdate);
      });
  };

  const onDataChangeCategory = e => {
    setRiderdata({
      ...riderData,
      category: e,
      divisionClassOne: defaultLookup,
      divisionClassTwo: defaultLookup,
    });

    let categoryLookUpList = getLookupArray('CATEGORY', lookUps);
    const matchingObject = findObjectById(categoryLookUpList, e.id);
    if (matchingObject) {
      const { children } = matchingObject;
      setDivisionOnelist(children!);
    }
    setDivisionTwoList([]);
  };

  const onDataChangeDivisionOne = e => {
    let division = getLookupArray('DIVISION', lookUps);
    let filteredDivisionTwoList = findMatchingDivisionClassAndRemoveSelected(
      e,
      division,
      divisionOneList,
    );
    setDivisionTwoList(filteredDivisionTwoList);
    setRiderdata({
      ...riderData,
      divisionClassOne: e,
      divisionClassTwo: defaultLookup,
    });
  };

  const handleImageSelect = e => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      setImageFile(file);
    }
  };

  const onBackNumberCheck = e => {
    let fieldsData = simpleValidator.current.fields;
    let emailValid = fieldsData['Back Number'];
    setForceUpdate(!forceUpdate);

    if (!emailValid) {
      simpleValidator?.current?.showMessageFor('Back Number');
    } else {
      if (action === 'edit') {
        checkBacknumberTaken(
          riderData?.backNumber ?? '',
          riderData.isTrial,
          riderId,
        );
      } else {
        checkBacknumberTaken(riderData?.backNumber ?? '');
      }
    }
  };

  const handleBackNumberChange = e => {
    const inputValue = e.target.value;
    if (inputValue === '' || /^\d*\.?\d*$/.test(inputValue)) {
      setRiderdata?.({
        ...riderData,
        backNumber:
          inputValue === '' ? null : parseFloat(inputValue).toString(),
      });
      if (isBacknumberTaken === false) {
        setIsBacknumberTaken(null);
      }
      setIsBacknumberTaken(null);
    }
  };

  const handleFeetChange = event => {
    const newFeet = parseInt(event);
    if (event && newFeet >= 0 && newFeet <= 9) {
      setHeightWeight(prevData => ({
        ...prevData!,
        feet: Math.floor(newFeet),
      }));
      if (riderData) {
        const totalInches = newFeet * 12 + (heightWeight?.inches || 0);
        const heightInCm = totalInches * 2.54;
        setRiderdata?.({ ...riderData, height: Number(heightInCm.toFixed(2)) });
      }
    } else if (!event) {
      setHeightWeight(prevData => ({ ...prevData!, feet: undefined }));
    }
  };

  const handleInchesChange = event => {
    const newInches = parseInt(event);
    if (event && newInches >= 0 && newInches <= 11) {
      setHeightWeight(prevData => ({
        ...prevData!,
        inches: Math.floor(newInches),
      }));
      if (riderData) {
        const totalInches = (heightWeight?.feet || 0) * 12 + newInches;
        const heightInCm = totalInches * 2.54;
        setRiderdata?.({ ...riderData, height: Number(heightInCm.toFixed(2)) });
      }
    } else if (!event) {
      setHeightWeight(prevData => ({
        ...prevData!,
        inches: undefined,
      }));
    }
  };

  const handleWeightChange = inputValue => {
    if (inputValue.length <= 3 && /^[0-9]*$/.test(inputValue)) {
      if (riderData) {
        setRiderdata?.({
          ...riderData,
          weight: inputValue,
        });
      }
      setHeightWeight(prevData => ({
        ...prevData!,
        weight: inputValue,
      }));
    }
  };

  const handleIsReturningRider = (_, value) => {
    setIsReturningRider(value);
    setSelectedReturningRider(undefined);
    onCancelClick();
  };

  const handleSeasonChange = e => {
    setSeasonValue(e);
    setSelectedReturningRider(undefined);
    setReturningRiderData([]); // ← clear stale results from previous season
    previousSearchValueRef.current = ''; // ← allow re-search with same value
    if (e?.id) {
      getRidersList(
        e.id,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        false,
      );
      onCancelClick();
    }
  };

  const handleReturningRiderChange = e => {
    setSelectedReturningRider(e);
  };

  return (
    <>
      <GridWrapper>
        {action === 'create' && (
          <CustomgridLayoutWrapper
            className="CustomgridLayoutWrapper"
            rows={[{ height: 'auto' }]}
            cols={[{ width: '100%' }]}
            style={{ marginBottom: '30px' }}
          >
            <p className="radiobtn-title">Are you a Returning Rider?</p>
            <CustomRadioButtonGroup
              onChange={handleIsReturningRider}
              value={isReturningRider}
              disabled={riderDataLoading}
            />
          </CustomgridLayoutWrapper>
        )}
        <CustomgridLayoutWrapper
          rows={[{ height: 'auto' }]}
          cols={[{ width: '30%' }, { width: '73.5%' }]}
          gap={{ rows: 20, cols: 30 }}
        >
          <GridLayoutItem>
            <ProfileImageUploadCard
              imgSrc={imgSrc}
              setImgSrc={setImgSrc}
              onSelectFile={handleImageSelect}
              uploadButtonLabel={`${imgSrc ? 'Change Image' : 'Upload Image'}`}
              uploadButtonType="primary"
              isLoader={riderDataLoading}
            />
          </GridLayoutItem>
          <GridLayoutItem>
            <CustomgridLayoutWrapper
              rows={[{ height: 'auto' }]}
              cols={[{ width: '45%' }, { width: '45%' }]}
              gap={{ rows: 20, cols: 10 }}
              className=""
            >
              <GridLayoutItem>
                {isReturningRider && action === 'create' ? (
                  <AdminDropDown
                    label="Rider Name"
                    placeholder=""
                    data={returningRiderData}
                    onDataChange={handleReturningRiderChange}
                    defaultValue={selectedReturningRider}
                    className="field-style"
                    // isLoader={riderDataLoading || loading}
                    onFilterChange={handleSearchInputChange}
                    validations="required"
                    validator={simpleValidator.current}
                    onScrollBottom={onRiderDropdownScrollBottom}
                  />
                ) : (
                  <AdminTextField
                    label="Rider First Name"
                    placeholder=""
                    value={riderData?.firstName}
                    onChange={handleChange}
                    name="firstName"
                    validations="required|max:100"
                    validator={simpleValidator.current}
                    className="field-style"
                    isLoader={riderDataLoading}
                  />
                )}
              </GridLayoutItem>
              <GridLayoutItem>
                {isReturningRider && action === 'create' ? (
                  <AdminDropDown
                    label="Season"
                    placeholder=""
                    data={getLookupArray('SEASON', lookUps)}
                    onDataChange={handleSeasonChange}
                    defaultValue={seasonValue}
                    className="field-style"
                    validations="required"
                    validator={simpleValidator.current}
                    // isLoader={riderDataLoading || loading}
                  />
                ) : (
                  <AdminTextField
                    label="Rider Last Name"
                    placeholder=""
                    value={riderData?.lastName}
                    onChange={handleChange}
                    name="lastName"
                    validations="required|max:100"
                    validator={simpleValidator.current}
                    className="field-style"
                    isLoader={riderDataLoading}
                  />
                )}
              </GridLayoutItem>
              <GridLayoutItem className="backnumber-wrapper">
                <StyledAdminTextField
                  label="Back Number"
                  placeholder=""
                  value={riderData?.backNumber!}
                  onChange={handleBackNumberChange}
                  name="backNumber"
                  className="field-style"
                  hideStar
                  isLoader={riderDataLoading}
                  validations={
                    riderData.isTrial === true
                      ? 'required|max:2'
                      : 'min:3|max:4|required'
                  }
                  validator={simpleValidator.current}
                  isReturningRider={isReturningRider && action === 'create'}
                  disabled={isReturningRider && action === 'create'}
                />
                {riderDataLoading ? (
                  <div style={{ paddingTop: '30px' }}>
                    <FormSkeletonLoader lineContent={1} textWidth={100} />
                  </div>
                ) : (
                  <>
                    {(!isReturningRider || action === 'edit') && (
                      <AdminCustomButton
                        className="check-button"
                        buttonType="save"
                        onClick={onBackNumberCheck}
                      >
                        Check
                      </AdminCustomButton>
                    )}
                  </>
                )}
                {isBacknumberTaken !== null && (
                  <span
                    className={`error-message ${
                      isBacknumberTaken === false
                        ? 'green-border'
                        : 'red-border'
                    }`}
                  >
                    Back number is {isBacknumberTaken === false ? '' : 'not '}
                    available
                  </span>
                )}
              </GridLayoutItem>
              <GridLayoutItem
                className={
                  isReturningRider && action === 'create'
                    ? ''
                    : 'backnumber-check-style'
                }
              >
                {riderDataLoading ? (
                  <FormSkeletonLoader lineContent={1} textWidth={100} />
                ) : (
                  <>
                    {isReturningRider && action === 'create' ? (
                      <AdminDropDown
                        label="Status "
                        placeholder=""
                        data={getLookupArray('ACTIVESTATUS', lookUps)}
                        onDataChange={data => {
                          setRiderdata({
                            ...riderData,
                            riderStatus: data,
                          });
                        }}
                        defaultValue={riderData?.riderStatus}
                        validations="required"
                        validator={simpleValidator.current}
                        className="field-style"
                        isLoader={riderDataLoading}
                      />
                    ) : (
                      <AdminCheckBox
                        label="Make this back number available for others"
                        value={riderData?.isAvailableBackNumber}
                        onChange={e =>
                          setRiderdata({
                            ...riderData,
                            isAvailableBackNumber: e.value,
                          })
                        }
                      />
                    )}
                  </>
                )}
              </GridLayoutItem>
              <GridLayoutItem>
                <CustomgridLayoutWrapper
                  rows={[{ height: 'auto' }]}
                  cols={[
                    { width: 'calc(50% - 5px)' },
                    { width: 'calc(50% - 5px)' },
                  ]}
                  gap={{ rows: 20, cols: 10 }}
                  className="grid-layout-sub"
                >
                  <GridLayoutItem>
                    <AdminTextField
                      label="Rider Height (ft)"
                      placeholder="Feet"
                      value={
                        heightWeight?.feet === undefined
                          ? ''
                          : heightWeight?.feet
                      }
                      onChange={e => {
                        const inputValue = e.target.value;
                        if (
                          inputValue === '' ||
                          /^\d{0,3}(\.\d{0,3})?$/.test(inputValue)
                        )
                          handleFeetChange(inputValue);
                      }}
                      type="number"
                      name="height"
                      className="field-style"
                      validator={simpleValidator.current}
                      validations="numeric|min:3,num|max:9,num"
                      isLoader={riderDataLoading}
                      min={50}
                      max={300}
                      hideStar
                      maxLength={3}
                      onKeyDown={e => {
                        if (['e', 'E', '+', '-'].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <AdminTextField
                      label="Inches"
                      placeholder="Inches"
                      value={
                        heightWeight?.inches === undefined
                          ? ''
                          : heightWeight?.inches
                      }
                      onChange={e => {
                        const inputValue = e.target.value;
                        if (
                          inputValue === '' ||
                          /^\d{0,3}(\.\d{0,3})?$/.test(inputValue)
                        ) {
                          handleInchesChange(inputValue);
                        }
                      }}
                      type="number"
                      name="inch"
                      className="field-style"
                      isLoader={riderDataLoading}
                      hideStar
                      maxLength={2}
                      onKeyDown={e => {
                        if (['e', 'E', '+', '-'].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </GridLayoutItem>
                </CustomgridLayoutWrapper>
              </GridLayoutItem>
              <GridLayoutItem>
                <AdminTextField
                  label="Rider Weight (lbs)"
                  placeholder="lbs"
                  value={
                    heightWeight?.weight === undefined
                      ? ''
                      : heightWeight?.weight!
                  }
                  onChange={e => {
                    const inputValue = e.target.value;
                    if (
                      inputValue === '' ||
                      /^\d{0,3}(\.\d{0,3})?$/.test(inputValue)
                    ) {
                      handleWeightChange(inputValue);
                    }
                  }}
                  name="weight"
                  validator={simpleValidator.current}
                  validations="numeric|min:30,num|max:300,num"
                  type="number"
                  className="field-style"
                  isLoader={riderDataLoading}
                  min={30}
                  max={300}
                  hideStar
                  maxLength={3}
                  onKeyDown={e => {
                    if (['e', 'E', '+', '-'].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                />
              </GridLayoutItem>
            </CustomgridLayoutWrapper>
          </GridLayoutItem>
        </CustomgridLayoutWrapper>
      </GridWrapper>
      <Wrapper>
        <CustomgridLayoutWrapper
          className="CustomgridLayoutWrapper"
          rows={[{ height: 'auto' }]}
          cols={[{ width: '32.7%' }, { width: '32.7%' }, { width: '32.7%' }]}
          gap={{ rows: 20, cols: 10 }}
        >
          <GridLayoutItem className="team-style">
            <AdminDropDown
              label="Team "
              placeholder=""
              data={getLookupArray('ACTIVETEAM', lookUps)}
              onDataChange={onDataChangeTeam}
              defaultValue={riderData?.team}
              validations="required"
              validator={simpleValidator.current}
              className="field-style"
              isLoader={riderDataLoading}
            />
            {isCategoryNotInTeam && (
              <span className="team-error-message">
                Selected team is not available,choose another team
              </span>
            )}
          </GridLayoutItem>
          <GridLayoutItem className="team-checkbox-grid-layout-item">
            {riderDataLoading ? (
              <div className="team-checkbox-style">
                <FormSkeletonLoader lineContent={1} textWidth={100} />
              </div>
            ) : (
              <AdminCheckBox
                label="Transferred team mid-season"
                className="team-checkbox-style"
                value={riderData?.isTransferredTeam}
                onChange={e =>
                  setRiderdata({
                    ...riderData,
                    isTransferredTeam: e.value,
                  })
                }
              />
            )}
          </GridLayoutItem>
          <GridLayoutItem>
            <AdminDropDown
              label="Category "
              placeholder=""
              data={categoryListFromTeam}
              onDataChange={onDataChangeCategory}
              defaultValue={riderData?.category}
              validations="required"
              validator={simpleValidator.current}
              className="field-style"
              disabled={isEmptyArray(categoryListFromTeam)}
              isLoader={riderDataLoading}
            />
          </GridLayoutItem>
          <GridLayoutItem>
            <AdminDropDown
              label="Division/Classes One"
              placeholder=""
              data={divisionOneList}
              onDataChange={onDataChangeDivisionOne}
              defaultValue={riderData?.divisionClassOne! ?? undefined}
              className="field-style"
              disabled={isEmptyArray(divisionOneList)}
              validations="required"
              validator={simpleValidator.current}
              isLoader={riderDataLoading}
            />
          </GridLayoutItem>
          <GridLayoutItem>
            <AdminDropDown
              label="Division/Classes Two"
              placeholder=""
              data={divisionTwoList}
              onDataChange={data => {
                setRiderdata({
                  ...riderData,
                  divisionClassTwo: data,
                });
              }}
              defaultValue={riderData?.divisionClassTwo ?? undefined}
              className="field-style"
              disabled={isEmptyArray(divisionTwoList)}
              validations="required"
              validator={simpleValidator.current}
              isLoader={riderDataLoading}
            />
          </GridLayoutItem>

          <GridLayoutItem>
            <AdminDatePicker
              title="Created Date "
              placeholder="month/day/year"
              value={
                riderData?.adminCreatedDate
                  ? new Date(riderData.adminCreatedDate)
                  : new Date()
              }
              onChange={e =>
                setRiderdata({
                  ...riderData,
                  adminCreatedDate: isoString(e.value),
                })
              }
              validations="required"
              validator={simpleValidator.current}
              className="field-style"
              mindate={new Date()}
              isLoader={riderDataLoading}
            />
          </GridLayoutItem>
          {riderDataLoading && !isReturningRider ? (
            <FormSkeletonLoader lineContent={1} textWidth={100} />
          ) : (
            <>
              {((!isReturningRider && action === 'create') ||
                action === 'edit') && (
                <GridLayoutItem className="tryit-wrapper">
                  <div className="checkbox">
                    <AdminCheckBox
                      label="Try-it"
                      value={riderData?.isTrial}
                      onChange={e =>
                        setRiderdata({
                          ...riderData,
                          isTrial: e.value,
                        })
                      }
                      style={{
                        cursor: action === 'edit' ? 'not-allowed' : 'pointer',
                      }}
                      isDisabled={action === 'edit'}
                    />
                  </div>
                  <div className="checkbox">
                    <AdminCheckBox
                      label="Is Paid"
                      value={riderData?.isPaid}
                      onChange={e =>
                        setRiderdata({
                          ...riderData,
                          isPaid: e.value,
                        })
                      }
                    />
                  </div>
                </GridLayoutItem>
              )}
            </>
          )}
          {(!isReturningRider || action !== 'create') && (
            <GridLayoutItem>
              <AdminDropDown
                label="Status "
                placeholder=""
                data={getLookupArray('ACTIVESTATUS', lookUps)}
                onDataChange={data => {
                  setRiderdata({
                    ...riderData,
                    riderStatus: data,
                  });
                }}
                defaultValue={riderData?.riderStatus}
                validations="required"
                validator={simpleValidator.current}
                className="field-style"
                isLoader={riderDataLoading}
              />
            </GridLayoutItem>
          )}
        </CustomgridLayoutWrapper>
      </Wrapper>
    </>
  );
};

export default RiderInformationFirstBlock;

const GridWrapper = styled.div`
  margin-bottom: 20px;

  @media (min-width: 1899px) and (max-width: 4000px) {
    .k-grid-layout {
      gap: 20px 15px !important;
    }
    .grid-layout-sub {
      grid-template-columns: 49% 48.5% !important;
    }
  }
  @media (max-width: 991px) {
    .k-grid-layout {
      grid-template-columns: 100% !important;
    }
  }

  .backnumber-wrapper {
    display: flex;
    align-items: center;
    gap: 10px;
    position: relative;
    .check-button {
      width: calc(25% - 5px);
      text-align: center;
      height: 100%;
      align-content: flex-start;
      padding-top: 30px;
      @media (min-width: 100px) and (max-width: 1290px) {
        button {
          padding: 0 5px !important;
        }
      }
    }
    .error-message {
      color: #f44336;
      font-size: 12px;
      display: inline-block;
      position: absolute;
      bottom: -18px;
      &.green-border {
        color: #3cb33c !important;
        font-size: 12px;
        display: inline-block;
      }
    }
  }
  .backnumber-check-style {
    align-content: flex-start;
    padding-top: 30px;
    label {
      color: #a3a3a3;
    }
  }
`;
const Wrapper = styled.div`
  .team-style {
    position: relative;
    .team-error-message {
      position: absolute;
      top: 72px;
      color: #f44336;
      font-size: 12px;
      width: max-content;
    }
  }
  .team-checkbox-style {
    label {
      color: #a3a3a3;
    }
  }
  .CustomgridLayoutWrapper {
    align-items: flex-start !important;
    .team-checkbox-grid-layout-item,
    .tryit-wrapper {
      height: 100%;
      display: flex;
      align-items: flex-start;
      margin-top: 32px;
    }
  }
  .status-dropdown {
    height: 90px;
  }
  margin-bottom: 20px;
  .k-grid-layout {
    align-items: center;
    .checkbox {
      .k-checkbox {
        background-color: #fff !important;
      }
      input[type='checkbox']:checked {
        background-color: #4764ff !important;
      }
      label {
        font-family: 'Inter';
        color: #a3a3a3;
      }
    }
  }
  @media (max-width: 991px) {
    .k-grid-layout {
      gap: 20px 15px !important;
      grid-template-columns: 50% 50% !important;
    }
  }
`;
const StyledAdminTextField = styled(AdminTextField)<{
  isReturningRider?: boolean;
}>`
  width: ${props => (props.isReturningRider ? '100%' : 'calc(100% - 75px)')};
`;
